<!--P006、P010、P011、P048、P049-->
<template>
  <div class="div_content">
    <div class="cs_margin_top_sm ui_hierarchy">
      <div class="cs_cursor_pointer ui_txt_hierarchy">供应商维护</div>
    </div>
    <!--查询栏-->
    <div class="cs_margin_top div_search bg_search cs_padding">
      <div class="cs_title_primary cs_text_default type_info_search">供应商</div>
      <input v-model="search.id" class="cs_input cs_radius_lg edtxt_info_search width_280">
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left">供应商类型</div>
      <div class="cs_radius_lg txt_info_search">独立供应商</div>
      <button class="ui_btn_search_yellow btn_search" type="button" @click="btnSearch">查询</button>
      <br>
      <div class="cs_title_primary cs_text_default cs_margin_top_sm type_info_search">货品</div>
      <search-select :options="search.materialSearchItems"
                     @option-key="updateMaterialName"
                     v-model="search.materialName"
                     :search-fn="acquireMaterialItem"
                     class="cs_input cs_radius_lg cs_margin_top_sm edtxt_info_search width_280 ui_margin_left_30"></search-select>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_top_sm cs_margin_left">启用状态</div>
      <web-select :options="SUPPLIER_STATUS_QUERY"
                  @option-key="updateStatus"
                  v-model="search.statusName"
                  class="cs_input cs_radius_lg cs_margin_top_sm edtxt_info_search ui_margin_left_30"></web-select>
    </div>
    <!--表格-->
    <div class="cs_margin_top div_search_result cs_padding_top">
      <div class="div_operation_table">
        <button @click="btnAdd" class="cs_btn cs_btn_sm ui_btn_blue cs_fr cs_margin_left_sm"
                type="button">添加独立供应商
        </button>
<!--        <button @click="btnDelete" class="cs_btn cs_btn_sm ui_btn_ghost_blue cs_fr cs_margin_left_sm"-->
<!--                type="button">删除-->
<!--        </button>-->
        <button v-show="isStop && isStopShow" @click="btnStart" class="cs_btn cs_btn_sm ui_btn_ghost_blue cs_fr"
                type="button">启用
        </button>
        <button v-show="!isStop && isStopShow" @click="btnStop" class="cs_btn cs_btn_sm ui_btn_ghost_blue cs_fr"
                type="button">停用
        </button>
      </div>
      <div class="cs_margin_top div_table">
        <table class="cs_table cs_td_divider_none" width="100%">
          <thead>
          <tr>
            <th width="40px">序号</th>
            <th width="151px">供应商编号</th>
            <th width="280px">供应商名称</th>
            <th width="224px">供货数量</th>
            <th width="224px">供应商类型</th>
            <th width="160px">启用状态</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item,index) in orderList" :class="{ 'cs_tr_selected': item.isSelected}" @click="btnSelectTableTr(item)">
            <td>{{index+1}}</td>
            <td><a @click.stop="$router.push({name:'SupplierDetail', query: {id:item.id,num:item.supplierNum}})">{{item.supplierNum}}</a></td>
            <td>{{item.supplierName}}</td>
            <td>{{item.materialCount}}</td>
            <td>{{SUPPLIER_TYPE[item.supplierType]}}</td>
            <td>{{SUPPLIER_STATUS[item.stop]}}</td>
          </tr>
          <tr v-for="(item,index) in (PAGE_SIZE-orderList.length)">
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="div_page_download">
        <button @click="btnExport" class="ui_btn_export cs_fl" style="width:116px;"
                type="button">采购价导出
        </button>
        <!--上一页-->
        <button v-show="search.pagination>1" @click="showList(search.pagination < 2?1:search.pagination-1)"
                class="btn_page_up" type="button">
        </button>
        <button v-show="search.pagination<=1" class="btn_page_up_disable" type="button"></button>
        <div class="current_page">{{search.pagination}}</div>
        <div class="oblique_line">/</div>
        <div class="total_page">{{search.totalPage}}</div>
        <!--下一页-->
        <button v-show="search.pagination!==search.totalPage" @click="showList(search.pagination+1)" class="btn_page_down" type="button"></button>
        <button v-show="search.pagination===search.totalPage" class="btn_page_down_disable" type="button"></button>
        <div @click="jump()" class="type_page_jump">跳转至</div>
        <input v-model="search.pageJump" class="txt_page_jump" type="text"
               @keyup="checkPositiveInt($event)" @blur="search.pageJump=checkPositiveInt($event)">
      </div>
    </div>
    <div class="div_bottom"></div>
  </div>
</template>

<script>
  import WebSelect from "../../components/web-select"
  import SearchSelect from "../../components/search-select";
  import {Page, PAGE_SIZE,SUPPLIER_TYPE,SUPPLIER_STATUS_QUERY,SUPPLIER_STATUS} from "../../assets/utils/constants"
  import StorageConst from "../../assets/utils/StorageConst";
  export default {
    name: "SupplierManage",
    components: {SearchSelect, WebSelect},
    data: function () {
      return {
        isStopShow: false,
        isStop: false,
        selectedId: "",
        selectedName: "",
        search: {
          id: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.SUPPLIER_MANAGE,"id", ""),
          materialId: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.SUPPLIER_MANAGE,"materialId", 0),
          materialName: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.SUPPLIER_MANAGE,"materialName", ""),
          materialSearchItems: [],
          statusId: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.SUPPLIER_MANAGE,"statusId", 0),
          statusName: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.SUPPLIER_MANAGE,"statusName", ""),
          statusSearchItems: [],
          pageJump: "",
          totalPage: "",
          pagination: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.SUPPLIER_MANAGE,"pagination", 1)
        },
        orderList: [],
        PAGE_SIZE: PAGE_SIZE,
        SUPPLIER_STATUS_QUERY: SUPPLIER_STATUS_QUERY,
        SUPPLIER_STATUS: SUPPLIER_STATUS,
        SUPPLIER_TYPE: SUPPLIER_TYPE,
      }
    },
    created: function () {
      this.showList(this.search.pagination);
    },
    mounted: function () {
    },
    methods:{
      showList(pagination) {
        this.selectedId = "";
        this.selectedName = "";
        this.isStop = false;
        this.isStopShow = false;
        this.$ajax.supplier.listSuppliers.bind(this)(this.search, new Page(PAGE_SIZE, pagination), (data) => {
          //显示列表
          this.search.totalPage = data.data.totalPage;
          this.search.pagination = data.data.pagination;
          let list = data.data.list;
          list.forEach((item) => {
            item.isSelected = false;
          });
          this.orderList = list;
          this.setStoreItem(StorageConst.LOCAL_PAGE_LIST.SUPPLIER_MANAGE, JSON.stringify(this.search));
        }, (data) => {
        }, true)
      },
      btnSelectTableTr(item){
        let selectedStatus = item.isSelected;
        this.orderList.forEach((item1) => {
          item1.isSelected = false;
        });
        item.isSelected = !selectedStatus;
        if(item.isSelected){
          this.selectedId = item.supplierNum;
          this.selectedName = item.supplierName;
          this.isStop = item.stop;
          this.isStopShow = true;
        }else {
          this.selectedId = "";
          this.selectedName = "";
          this.isStop = false;
          this.isStopShow = false;
        }
      },
      btnSearch(){
        this.showList(1);
      },
      jump() {
        if (!this.isEmpty(this.search.pageJump)) {
          if(this.search.pageJump>this.search.totalPage){
            this.showList(this.search.totalPage);
          }else {
            this.showList(this.search.pageJump);
          }
        }
      },
      btnStop(){
        if(this.isEmpty(this.selectedId)){
          this.$toast("请先选中一条数据");
          return;
        }
        this.$alert("确认停用供应商"+this.selectedName+"吗？", (clickConfirm) => {
          if (clickConfirm) {
            this.$ajax.supplier.stop.bind(this)(this.selectedId, true, (data) => {
              this.$toast("停用成功");
              this.showList(this.search.pagination);
            }, (data) => {
            }, true)
          }
        }, true);
      },
      btnStart(){
        if(this.isEmpty(this.selectedId)){
          this.$toast("请先选中一条数据");
          return;
        }
        this.$alert("确认启用供应商"+this.selectedName+"吗？", (clickConfirm) => {
          if (clickConfirm) {
            this.$ajax.supplier.stop.bind(this)(this.selectedId, false, (data) => {
              this.$toast("启用成功");
              this.showList(this.search.pagination);
            }, (data) => {
            }, true)
          }
        }, true);
      },
      btnDelete(){
        if(this.isEmpty(this.selectedId)){
          this.$toast("请先选中一条数据");
          return;
        }
        // this.$ajax.supplier.delete.bind(this)(this.selectedId, (data) => {
        //   this.$toast("删除成功");
        //   this.isStop = false;
        //   this.isStopShow = false;
        //   this.showList(this.search.pagination);
        // }, (data) => {
        // }, true)
      },
      btnAdd(){
        this.$router.push({name:'SupplierAdd'});
      },

      acquireMaterialItem(search) {
        this.$ajax.common.searchMaterial.bind(this)(search,(data) => {
          let array = [];
          for (let i = 0; i < data.data.length; i++) {
            array.push({
              key: data.data[i].id,
              value: data.data[i].materialNum + "  " + data.data[i].materialName,
            })
          }
          this.search.materialSearchItems = array;
        }, this.failDefault, false);
      },
      updateMaterialName(key) {
        this.search.materialId = key;
        if(this.isEmpty(key)){
          this.search.materialName = "";
          this.search.materialId = 0;
        }
      },
      updateStatus(key) {
        this.search.statusId = key;
      },
      btnExport(){
        this.$ajax.supplier.exportMaterial.bind(this)((response) => {
          let fileName = "采购价-"+this.getNowDateNoDivider()+".xls";
          this.downloadFileStream(response.data, fileName);
        }, (data) => {
        }, true)
      },
      failDefault() {
      },
      timeToDate(time){
        return this.isEmpty(time)?"":time.substring(0,10)
      },
    }
  }
</script>

<style scoped>
  .width_280{width: 280px;}
  .margin_left_37{margin-left: 37px;}
</style>



// WEBPACK FOOTER //
// src/page/supplier/SupplierManage.vue